export default {"src":"/_next/static/media/positionOpposition.cffa6398.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};